var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCleaningFeedbackLevel1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stain",
    transform: "translate(31.000000, 27.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#00172E",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6132723,38.0245383 L21.1099662,35.2919813 C18.9490288,33.9790501 16.1817398,34.3225772 14.3989417,36.125078 L6.77627231,43.833999 C5.4084498,45.2058415 3.26497322,45.3887204 1.689222,44.2680202 C0.113470778,43.1473199 -0.44121996,41.0454599 0.372790681,39.2797373 L6.68840293,25.650276 C7.38846909,24.1601718 7.38846909,22.4306071 6.68840293,20.9405029 L2.71231313,12.187434 C1.87093342,10.3407927 2.25671471,8.15951922 3.67887639,6.72231998 C6.1611866,4.2008141 8.79726823,5.61152444 11.9385988,6.6667802 C14.2241445,7.43959404 16.7408561,6.61522324 18.1443744,4.63402436 L20.0115988,1.97922302 C21.2026021,0.308175889 23.3204792,-0.399782261 25.2616084,0.22426417 C27.2027377,0.8483106 28.5276407,2.66307532 28.5459131,4.722888 L28.5459131,7.74425188 C28.5459131,8.35772731 29.0376689,8.85504742 29.6442805,8.85504742 L30.8744519,8.85504742 C32.9846879,8.86053188 34.8962144,10.1152025 35.7605095,12.0621141 C36.6248045,14.0090256 36.2816975,16.2873776 34.8834927,17.8858152 L30.7426478,22.6400201 C29.3091308,24.2664478 28.948344,26.5903164 29.8200193,28.5827762 L31.5883907,32.6038561 C32.3487654,34.3025214 31.9235258,36.3041491 30.540347,37.5370592 C29.6182279,38.3589993 27.9758696,38.5214923 25.6132723,38.0245383 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaningFeedbackLevel1);
export default __webpack_public_path__ + "static/media/cleaning-feedback-level-1.f13bd02301c3acc10391bbde8672a2fa.svg";
export { ForwardRef as ReactComponent };